import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { IconModule } from '@rd/shared-legacy/components/icon/icon.module';
import { FormBuilderFieldWrapperComponent } from './components/form-builder-field-wrapper/form-builder-field-wrapper.component';
import { FormBuilderFieldsetComponent } from './components/form-builder-fieldset/form-builder-fieldset.component';
import { FormBuilderInputComponent } from './components/form-builder-input/form-builder-input.component';
import { FormBuilderService } from './services/form-builder.service';

const declaredComponents: any[] = [
  FormBuilderFieldsetComponent,
  FormBuilderFieldWrapperComponent,
  FormBuilderInputComponent,
];

const exportComponents: any[] = [
  FormBuilderFieldsetComponent,
  FormBuilderFieldWrapperComponent,
  FormBuilderInputComponent,
];

@NgModule({
  declarations: [...declaredComponents],
  exports: [
    ...exportComponents,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    ReactiveFormsModule,
  ],
  providers: [FormBuilderService],
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    ReactiveFormsModule,
    TranslateModule,
    IconModule,
  ],
})
export class FormBuilderModule {}
